export interface MangaItem {
  id: string;
  title: string;
  author: string;
  category: string;
  categorySlug: string;
  cover: string;
  description: string;
  rating: number;
  views: number;
  chapterCount: number;
  latestChapter: string;
  status: '连载中' | '已完结';
  tags: string[];
  chapters: MangaChapter[];
  featured?: boolean;
  hot?: boolean;
}

export interface MangaChapter {
  id: string;
  title: string;
  number: number;
  date: string;
}

export const mangaCategories = [
  { name: '全部', slug: 'all', icon: 'ri-grid-line' },
  { name: '热血', slug: 'rexue', icon: 'ri-fire-line' },
  { name: '恋爱', slug: 'lianai', icon: 'ri-heart-line' },
  { name: '奇幻', slug: 'qihuan', icon: 'ri-magic-line' },
  { name: '动作', slug: 'dongzuo', icon: 'ri-swap-line' },
  { name: '悬疑', slug: 'xuanyi', icon: 'ri-search-eye-line' },
  { name: '搞笑', slug: 'gaoxiao', icon: 'ri-emotion-laugh-line' },
  { name: '校园', slug: 'xiaoyuan', icon: 'ri-building-line' },
  { name: '古风', slug: 'gufeng', icon: 'ri-vip-crown-line' },
];

export const mangaList: MangaItem[] = [
  {
    id: '1',
    title: '我独自升级',
    author: 'Chugong / DUBU',
    category: '动作',
    categorySlug: 'dongzuo',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20powerful%20male%20hunter%20with%20dark%20hair%20and%20glowing%20eyes%20standing%20in%20a%20dungeon%20with%20monsters%20silhouettes%20behind%20him%2C%20dramatic%20lighting%2C%20anime%20cover%20art%20style%2C%20vibrant%20warm%20colors%2C%20clean%20composition&width=400&height=560&seq=manga-cover-01&orientation=portrait',
    description: '十年前，世界上突然出现了连接异次元与这个世界的"门"，随之觉醒的还有被称为"猎人"的超能力者。然而，并不是所有的猎人都很强大。作为人类最弱兵器的E级猎人成振宇，某天在一次突袭任务中，被卷入了致命的危机。在死亡的边缘，他获得了神秘的力量——「系统」，一个只有他能看到的升级任务面板。从此，踏上从最弱到最强的逆袭之路！',
    rating: 9.7,
    views: 12850000,
    chapterCount: 200,
    latestChapter: '第200话 终章',
    status: '已完结',
    tags: ['系统', '升级', '逆袭', '战斗'],
    featured: true,
    hot: true,
    chapters: [
      { id: 'ch1-1', title: '第1话 最弱的猎人', number: 1, date: '2022-01-15' },
      { id: 'ch1-2', title: '第2话 系统的觉醒', number: 2, date: '2022-01-22' },
      { id: 'ch1-3', title: '第3话 第一次升级', number: 3, date: '2022-01-29' },
      { id: 'ch1-199', title: '第199话 最后的决战', number: 199, date: '2024-06-01' },
      { id: 'ch1-200', title: '第200话 终章', number: 200, date: '2024-06-08' },
    ],
  },
  {
    id: '2',
    title: '全知读者视角',
    author: 'sing N song / Sleepy-C',
    category: '奇幻',
    categorySlug: 'qihuan',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20young%20man%20with%20glasses%20holding%20a%20book%20surrounded%20by%20floating%20text%20and%20apocalyptic%20scene%20behind%20him%2C%20fantasy%20cover%20art%2C%20muted%20warm%20tones%2C%20dramatic%20composition&width=400&height=560&seq=manga-cover-02&orientation=portrait',
    description: '作为一名普通的上班族，金独子唯一的乐趣就是阅读网络小说《在灭亡的世界中存活的三种方法》。当这部连载了十年的小说终于完结的那天，世界突然变成了小说中的场景。而金独子，是唯一知道这个世界结局的人。凭借对剧情的了解，他能否在这个残酷的末世中存活下去？',
    rating: 9.8,
    views: 15600000,
    chapterCount: 180,
    latestChapter: '第180话 新的开始',
    status: '连载中',
    tags: ['末世', '小说', '知识', '生存'],
    featured: true,
    hot: true,
    chapters: [
      { id: 'ch2-1', title: '第1话 小说的终章', number: 1, date: '2022-03-10' },
      { id: 'ch2-2', title: '第2话 末日的开始', number: 2, date: '2022-03-17' },
      { id: 'ch2-179', title: '第179话 命运的选择', number: 179, date: '2024-07-20' },
      { id: 'ch2-180', title: '第180话 新的开始', number: 180, date: '2024-07-27' },
    ],
  },
  {
    id: '3',
    title: '女神降临',
    author: 'Yaongyi',
    category: '恋爱',
    categorySlug: 'lianai',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20beautiful%20girl%20with%20long%20hair%20and%20perfect%20makeup%20standing%20in%20front%20of%20a%20mirror%20with%20school%20uniform%2C%20romantic%20comedy%20cover%20art%2C%20soft%20warm%20pinkish%20tones%2C%20elegant%20and%20clean&width=400&height=560&seq=manga-cover-03&orientation=portrait',
    description: '因为长相平凡而一直被欺负的任朱静，通过化妆彻底改变了自己的外貌，成为了校园里的"女神"。但她必须小心翼翼地隐藏自己素颜的秘密。当两个完美的男生同时走进她的生活——一个是冷酷的学霸李修豪，另一个是阳光的校草韩书竣——她的双重生活开始变得岌岌可危。',
    rating: 9.5,
    views: 20300000,
    chapterCount: 230,
    latestChapter: '第230话 永恒',
    status: '已完结',
    tags: ['化妆', '校园', '三角恋', '变身'],
    featured: true,
    hot: true,
    chapters: [
      { id: 'ch3-1', title: '第1话 化妆的力量', number: 1, date: '2018-06-01' },
      { id: 'ch3-2', title: '第2话 校园女神', number: 2, date: '2018-06-08' },
      { id: 'ch3-229', title: '第229话 真正的美丽', number: 229, date: '2023-12-15' },
      { id: 'ch3-230', title: '第230话 永恒', number: 230, date: '2023-12-22' },
    ],
  },
  {
    id: '4',
    title: '外貌至上主义',
    author: '朴泰俊',
    category: '搞笑',
    categorySlug: 'gaoxiao',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20funny%20illustration%20of%20an%20overweight%20teenager%20and%20a%20handsome%20popular%20boy%20side%20by%20side%20with%20school%20lockers%20background%2C%20comedic%20cover%20art%2C%20bright%20warm%20colors%2C%20energetic%20composition&width=400&height=560&seq=manga-cover-04&orientation=portrait',
    description: '胖乎乎的朴玄硕因为长相问题在学校里备受欺凌。当他向妈妈提出想转学时，却意外发现了一个惊天秘密——他其实有着双重身份！当他睡着时，会变成一个又高又帅的完美少年。于是，他开始在两个身体、两种人生之间来回切换，体验着截然不同的校园生活。',
    rating: 9.3,
    views: 18900000,
    chapterCount: 320,
    latestChapter: '第320话',
    status: '连载中',
    tags: ['搞笑', '校园', '变身', '双面人生'],
    hot: true,
    chapters: [
      { id: 'ch4-1', title: '第1话 胖子的日常', number: 1, date: '2015-05-10' },
      { id: 'ch4-2', title: '第2话 另一个我', number: 2, date: '2015-05-17' },
      { id: 'ch4-319', title: '第319话', number: 319, date: '2024-08-01' },
      { id: 'ch4-320', title: '第320话', number: 320, date: '2024-08-08' },
    ],
  },
  {
    id: '5',
    title: '重生之都市修仙',
    author: 'Jaeu / 羊羊',
    category: '热血',
    categorySlug: 'rexue',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20young%20cultivator%20with%20flowing%20hair%20and%20martial%20arts%20robe%20standing%20on%20a%20modern%20city%20rooftop%20with%20energy%20aura%2C%20action%20fantasy%20cover%20art%2C%20warm%20golden%20tones%2C%20dynamic%20pose&width=400&height=560&seq=manga-cover-05&orientation=portrait',
    description: '一代修仙大能陈凡，在渡劫失败后重生回到了高中时代。这一世，他带着前世的记忆和修仙功法归来，决心弥补所有遗憾，保护所爱之人。在这座看似平凡的城市中，一个修仙者的传奇悄然拉开了序幕。',
    rating: 9.6,
    views: 11200000,
    chapterCount: 156,
    latestChapter: '第156话 破境',
    status: '连载中',
    tags: ['重生', '修仙', '都市', '强者归来'],
    hot: true,
    chapters: [
      { id: 'ch5-1', title: '第1话 渡劫失败', number: 1, date: '2023-01-05' },
      { id: 'ch5-2', title: '第2话 重返高中', number: 2, date: '2023-01-12' },
      { id: 'ch5-155', title: '第155话 大战在即', number: 155, date: '2024-07-25' },
      { id: 'ch5-156', title: '第156话 破境', number: 156, date: '2024-08-01' },
    ],
  },
  {
    id: '6',
    title: '公爵的契约未婚妻',
    author: 'Milcha / 鲸鱼',
    category: '古风',
    categorySlug: 'gufeng',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20elegant%20noble%20lady%20with%20elaborate%20gown%20and%20jewelry%20standing%20in%20a%20luxurious%20castle%20ballroom%2C%20romance%20fantasy%20cover%20art%2C%20warm%20peach%20and%20gold%20tones%2C%20refined%20composition&width=400&height=560&seq=manga-cover-06&orientation=portrait',
    description: '穿越成了小说中的配角，而且还是注定要被未婚夫毒死的可怜女配？莱利娜决定在被杀死之前先解除婚约。可是，那个冷血无情的公爵未婚夫诺亚——好像并不打算放手。一场充满误会与心动的契约婚姻，就此展开。',
    rating: 9.4,
    views: 9800000,
    chapterCount: 140,
    latestChapter: '第140话 告白',
    status: '已完结',
    tags: ['穿越', '宫廷', '契约婚姻', '恋爱'],
    featured: true,
    chapters: [
      { id: 'ch6-1', title: '第1话 穿越成配角', number: 1, date: '2022-08-20' },
      { id: 'ch6-2', title: '第2话 公爵的婚约', number: 2, date: '2022-08-27' },
      { id: 'ch6-139', title: '第139话 最后的考验', number: 139, date: '2024-03-10' },
      { id: 'ch6-140', title: '第140话 告白', number: 140, date: '2024-03-17' },
    ],
  },
  {
    id: '7',
    title: '某天成为公主',
    author: 'Plutus / Spoon',
    category: '古风',
    categorySlug: 'gufeng',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20cute%20princess%20with%20blonde%20hair%20and%20pink%20dress%20in%20a%20beautiful%20royal%20garden%20with%20castle%20background%2C%20fantasy%20romance%20cover%20art%2C%20soft%20warm%20pastel%20tones%2C%20whimsical&width=400&height=560&seq=manga-cover-07&orientation=portrait',
    description: '一觉醒来发现自己变成了小说中的公主——还是那个被亲生父亲克劳德大帝杀害的悲剧公主阿塔纳西娅？！为了活命，她必须想尽办法讨好这个冷酷无情的父皇。然而，她不知道的是，帝国的命运正悄悄与她的人生交织在一起。',
    rating: 9.6,
    views: 13500000,
    chapterCount: 125,
    latestChapter: '第125话 父女',
    status: '连载中',
    tags: ['穿越', '公主', '父女', '宫廷'],
    hot: true,
    chapters: [
      { id: 'ch7-1', title: '第1话 醒来成公主', number: 1, date: '2021-11-15' },
      { id: 'ch7-2', title: '第2话 冷酷的父皇', number: 2, date: '2021-11-22' },
      { id: 'ch7-124', title: '第124话 真相', number: 124, date: '2024-06-20' },
      { id: 'ch7-125', title: '第125话 父女', number: 125, date: '2024-06-27' },
    ],
  },
  {
    id: '8',
    title: '剑尊归来',
    author: 'Lico / 大元',
    category: '热血',
    categorySlug: 'rexue',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20powerful%20swordsman%20with%20long%20sword%20and%20traditional%20martial%20arts%20outfit%20standing%20on%20a%20mountain%20peak%20at%20sunset%2C%20action%20cover%20art%2C%20dramatic%20warm%20orange%20and%20red%20tones%2C%20heroic%20pose&width=400&height=560&seq=manga-cover-08&orientation=portrait',
    description: '天下第一剑尊林寒星，在与魔教教主的大战中同归于尽。百年之后，他重生在一个无名剑客身上。曾经的最强者沦为弱者，曾经的威名已成传说。然而剑尊之魂不灭，他发誓要让这个江湖重新记住他的名字！',
    rating: 9.5,
    views: 8700000,
    chapterCount: 108,
    latestChapter: '第108话 剑尊之名',
    status: '连载中',
    tags: ['武侠', '重生', '剑道', '强者归来'],
    hot: true,
    chapters: [
      { id: 'ch8-1', title: '第1话 百年之后', number: 1, date: '2023-06-10' },
      { id: 'ch8-2', title: '第2话 无名剑客', number: 2, date: '2023-06-17' },
      { id: 'ch8-107', title: '第107话 决战前夕', number: 107, date: '2024-07-20' },
      { id: 'ch8-108', title: '第108话 剑尊之名', number: 108, date: '2024-07-27' },
    ],
  },
  {
    id: '9',
    title: '反派千金的生存法则',
    author: 'Eunren / 花灵',
    category: '恋爱',
    categorySlug: 'lianai',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20elegant%20villainess%20with%20dark%20hair%20and%20red%20dress%20holding%20a%20fan%20in%20a%20noble%20mansion%20study%20room%2C%20romance%20fantasy%20cover%20art%2C%20warm%20amber%20and%20crimson%20tones%2C%20mysterious&width=400&height=560&seq=manga-cover-09&orientation=portrait',
    description: '穿成了小说中的反派千金，按照剧情她注定要被女主和男主联手除掉。为了活下去，她决定避开所有Flag——不与女主为敌、不与男主扯上关系、安安静静做个路人甲。可是命运似乎并不打算放过她……',
    rating: 9.2,
    views: 7600000,
    chapterCount: 95,
    latestChapter: '第95话 命运的转折',
    status: '连载中',
    tags: ['穿越', '反派', '生存', '恋爱'],
    chapters: [
      { id: 'ch9-1', title: '第1话 觉醒的配角', number: 1, date: '2024-01-10' },
      { id: 'ch9-2', title: '第2话 避开死亡Flag', number: 2, date: '2024-01-17' },
      { id: 'ch9-94', title: '第94话 隐藏的真相', number: 94, date: '2024-07-15' },
      { id: 'ch9-95', title: '第95话 命运的转折', number: 95, date: '2024-07-22' },
    ],
  },
  {
    id: '10',
    title: '末日剑神',
    author: 'KIM / Dragon',
    category: '动作',
    categorySlug: 'dongzuo',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20warrior%20wielding%20a%20glowing%20sword%20in%20a%20post%20apocalyptic%20city%20with%20monsters%20and%20ruins%2C%20action%20cover%20art%2C%20warm%20fiery%20tones%2C%20intense%20battle%20scene&width=400&height=560&seq=manga-cover-10&orientation=portrait',
    description: '末日降临，怪物肆虐，人类文明一夜之间崩塌。曾经的击剑教练韩志浩，在绝境中觉醒了独一无二的剑术系统。在这个弱肉强食的新世界里，他要用手中的剑劈开黑暗，守护人类最后的希望。',
    rating: 9.1,
    views: 6500000,
    chapterCount: 85,
    latestChapter: '第85话 觉醒',
    status: '连载中',
    tags: ['末世', '系统', '剑术', '生存'],
    chapters: [
      { id: 'ch10-1', title: '第1话 末日降临', number: 1, date: '2024-03-15' },
      { id: 'ch10-2', title: '第2话 剑术系统', number: 2, date: '2024-03-22' },
      { id: 'ch10-84', title: '第84话 绝境', number: 84, date: '2024-07-28' },
      { id: 'ch10-85', title: '第85话 觉醒', number: 85, date: '2024-08-04' },
    ],
  },
  {
    id: '11',
    title: '校园诡异事件簿',
    author: 'Han Dal / Ghost',
    category: '悬疑',
    categorySlug: 'xuanyi',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20mysterious%20student%20with%20flashlight%20in%20a%20dark%20school%20corridor%20at%20night%20with%20ghostly%20shadows%2C%20thriller%20cover%20art%2C%20muted%20warm%20sepia%20tones%2C%20suspenseful&width=400&height=560&seq=manga-cover-11&orientation=portrait',
    description: '转学生李智恩来到了一所充满诡异传说的学校。深夜走廊的脚步声、空教室里的钢琴声、以及那个只在镜子里出现的神秘少女。和学校的侦探社一起，她开始揭开这些超自然现象背后的惊人真相。',
    rating: 9.0,
    views: 5200000,
    chapterCount: 72,
    latestChapter: '第72话 最后的谜题',
    status: '连载中',
    tags: ['悬疑', '校园', '超自然', '推理'],
    chapters: [
      { id: 'ch11-1', title: '第1话 深夜的脚步声', number: 1, date: '2024-05-01' },
      { id: 'ch11-2', title: '第2话 镜中的少女', number: 2, date: '2024-05-08' },
      { id: 'ch11-71', title: '第71话 真相大白', number: 71, date: '2024-08-01' },
      { id: 'ch11-72', title: '第72话 最后的谜题', number: 72, date: '2024-08-08' },
    ],
  },
  {
    id: '12',
    title: '猫咪咖啡厅的魔法师',
    author: 'Yuni / Latte',
    category: '搞笑',
    categorySlug: 'gaoxiao',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20cute%20barista%20with%20magical%20cats%20in%20a%20cozy%20cat%20cafe%20with%20floating%20coffee%20cups%20and%20sparkles%2C%20comedy%20fantasy%20cover%20art%2C%20warm%20cozy%20tones%2C%20charming&width=400&height=560&seq=manga-cover-12&orientation=portrait',
    description: '魔法学院最差的毕业生柳贤宇，被安排到人类世界经营一家猫咪咖啡厅作为实习考核。然而，这里的猫咪们全部都是——被变成猫的魔法师前辈？！一边伺候傲娇的猫前辈们，一边努力不让人类顾客发现秘密的爆笑日常，就此展开！',
    rating: 9.0,
    views: 4800000,
    chapterCount: 60,
    latestChapter: '第60话 毕业',
    status: '连载中',
    tags: ['搞笑', '魔法', '猫咪', '日常'],
    chapters: [
      { id: 'ch12-1', title: '第1话 最差魔法师', number: 1, date: '2024-06-10' },
      { id: 'ch12-2', title: '第2话 猫前辈们', number: 2, date: '2024-06-17' },
      { id: 'ch12-59', title: '第59话 实习结束', number: 59, date: '2024-08-03' },
      { id: 'ch12-60', title: '第60话 毕业', number: 60, date: '2024-08-10' },
    ],
  },
  {
    id: '13',
    title: '篮球少年',
    author: 'Lee Hyun / Storm',
    category: '校园',
    categorySlug: 'xiaoyuan',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20passionate%20basketball%20player%20dribbling%20on%20a%20school%20court%20with%20sunset%20light%20and%20cheering%20crowd%2C%20sports%20cover%20art%2C%20warm%20energetic%20tones%2C%20dynamic%20action&width=400&height=560&seq=manga-cover-13&orientation=portrait',
    description: '身高只有168cm的姜泰河，拥有着无人能及的对篮球的热爱。凭借惊人的速度和精准的三分球，他带领着默默无闻的校园篮球队，一路杀向全国大赛。这是一个关于梦想、汗水和永不言弃的故事。',
    rating: 9.3,
    views: 7100000,
    chapterCount: 115,
    latestChapter: '第115话 全国大赛',
    status: '连载中',
    tags: ['校园', '篮球', '热血', '青春'],
    chapters: [
      { id: 'ch13-1', title: '第1话 168cm的篮球梦', number: 1, date: '2023-08-20' },
      { id: 'ch13-2', title: '第2话 初露锋芒', number: 2, date: '2023-08-27' },
      { id: 'ch13-114', title: '第114话 半决赛', number: 114, date: '2024-07-15' },
      { id: 'ch13-115', title: '第115话 全国大赛', number: 115, date: '2024-07-22' },
    ],
  },
  {
    id: '14',
    title: '影后归来',
    author: 'Park Soo / Star',
    category: '恋爱',
    categorySlug: 'lianai',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20glamorous%20actress%20on%20a%20red%20carpet%20with%20camera%20flashes%20and%20elegant%20evening%20gown%2C%20romance%20drama%20cover%20art%2C%20warm%20golden%20and%20rose%20tones%2C%20sophisticated&width=400&height=560&seq=manga-cover-14&orientation=portrait',
    description: '曾红极一时的影后韩素希，在事业巅峰期遭遇背叛，一夜之间跌落谷底。十年后，她以全新的面貌重返娱乐圈。这一次，她不仅要夺回影后之位，更要对当年陷害她的人一一展开复仇。而那个曾经抛弃她的初恋，如今已是韩国顶级的娱乐公司总裁……',
    rating: 9.4,
    views: 8900000,
    chapterCount: 88,
    latestChapter: '第88话 影后的逆袭',
    status: '连载中',
    tags: ['娱乐圈', '复仇', '恋爱', '逆袭'],
    chapters: [
      { id: 'ch14-1', title: '第1话 跌落神坛', number: 1, date: '2024-02-18' },
      { id: 'ch14-2', title: '第2话 十年后', number: 2, date: '2024-02-25' },
      { id: 'ch14-87', title: '第87话 重返巅峰', number: 87, date: '2024-07-28' },
      { id: 'ch14-88', title: '第88话 影后的逆袭', number: 88, date: '2024-08-04' },
    ],
  },
  {
    id: '15',
    title: '魔王学院的不适任者',
    author: 'Shu / Magic',
    category: '奇幻',
    categorySlug: 'qihuan',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20powerful%20demon%20king%20in%20school%20uniform%20with%20dark%20magic%20aura%20in%20a%20magical%20academy%20hallway%2C%20fantasy%20cover%20art%2C%20warm%20dark%20amber%20tones%2C%20majestic&width=400&height=560&seq=manga-cover-15&orientation=portrait',
    description: '两千年前，魔王阿诺斯厌倦了无尽的战争，转生到了和平的未来。然而，未来的魔法学院把他评为"不适任者"——因为他的魔法太强了？在所有人都把他当成杂鱼的世界里，魔王大人不慌不忙地开始了他悠闲（？）的校园生活。',
    rating: 9.1,
    views: 6700000,
    chapterCount: 70,
    latestChapter: '第70话 魔王的余裕',
    status: '连载中',
    tags: ['魔王', '学院', '魔法', '强者'],
    chapters: [
      { id: 'ch15-1', title: '第1话 转生的魔王', number: 1, date: '2024-04-05' },
      { id: 'ch15-2', title: '第2话 不适任者', number: 2, date: '2024-04-12' },
      { id: 'ch15-69', title: '第69话 真相浮现', number: 69, date: '2024-07-30' },
      { id: 'ch15-70', title: '第70话 魔王的余裕', number: 70, date: '2024-08-06' },
    ],
  },
  {
    id: '16',
    title: '甜蜜的陷阱',
    author: 'Jung Min / Honey',
    category: '悬疑',
    categorySlug: 'xuanyi',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20mysterious%20couple%20in%20a%20dimly%20lit%20luxury%20apartment%20with%20hidden%20clues%20and%20secrets%2C%20romantic%20thriller%20cover%20art%2C%20warm%20dark%20crimson%20tones%2C%20suspenseful%20elegance&width=400&height=560&seq=manga-cover-16&orientation=portrait',
    description: '新婚妻子朴美妍发现丈夫的每一个"完美"举动都暗藏玄机。家里的一切——从食物的摆放到夜晚的梦话——都像是一场精心设计的表演。当她开始暗中调查，一段被掩埋的黑暗真相逐渐浮出水面……这段婚姻，从一开始就是陷阱。',
    rating: 9.3,
    views: 5900000,
    chapterCount: 55,
    latestChapter: '第55话 面具之下',
    status: '连载中',
    tags: ['悬疑', '婚姻', '黑暗', '反转'],
    chapters: [
      { id: 'ch16-1', title: '第1话 完美丈夫', number: 1, date: '2024-06-20' },
      { id: 'ch16-2', title: '第2话 第一丝裂痕', number: 2, date: '2024-06-27' },
      { id: 'ch16-54', title: '第54话 最后的线索', number: 54, date: '2024-08-02' },
      { id: 'ch16-55', title: '第55话 面具之下', number: 55, date: '2024-08-09' },
    ],
  },
];

export const aboutStats = {
  totalManga: 5000,
  totalChapters: 120000,
  totalViews: 250000000,
  dailyActiveUsers: 150000,
};

export const aboutFeatures = [
  {
    icon: 'ri-book-open-line',
    title: '海量韩漫资源',
    description: '收录超过5000部韩国漫画，涵盖热血、恋爱、奇幻、悬疑等多种类型，每日更新，让您畅享阅读乐趣。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '无删减完整版',
    description: '坚持提供原汁原味的无删减内容，确保每一部作品的故事情节完整呈现，保留作者最真实的创作意图。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '下拉式阅读体验',
    description: '专为移动端优化的下拉式阅读模式，流畅丝滑的翻页体验，让您沉浸在漫画世界中畅读无阻。',
  },
  {
    icon: 'ri-star-line',
    title: '优质内容精选',
    description: '专业的编辑团队精心筛选，只收录高品质的韩国漫画作品，为读者提供最优质的阅读选择。',
  },
];

export const faqData = [
  {
    question: '韩国漫画网的漫画都是免费的吗？',
    answer: '是的！韩国漫画网上所有的韩漫作品全部免费在线阅读。我们致力于为中文读者提供最优质的韩漫阅读体验，不收取任何费用。您只需要访问我们的网站，即可畅享所有漫画内容。',
  },
  {
    question: '网站上的漫画是无删减版本吗？',
    answer: '我们提供的所有韩漫内容均为无删减完整版，确保您看到的是原作者创作的原汁原味的作品。我们尊重每一位创作者的劳动成果，也尊重读者的阅读体验。',
  },
  {
    question: '什么是下拉式阅读模式？',
    answer: '下拉式阅读是韩国漫画（Webtoon）独有的阅读方式。与传统的翻页漫画不同，下拉式漫画采用垂直滚动的方式，您只需向下滑动即可连续阅读，无需翻页。这种模式专为手机和电脑屏幕优化，提供更加流畅沉浸的阅读体验。',
  },
  {
    question: '网站多久更新一次内容？',
    answer: '我们每天都会更新漫画内容！热门连载作品通常每周更新一话，我们的团队会在第一时间为您同步最新章节。您可以将喜欢的漫画加入收藏，这样就不会错过任何更新了。',
  },
  {
    question: '如何找到我喜欢的类型的漫画？',
    answer: '您可以通过首页的分类导航浏览不同类别的漫画，也可以在搜索框中直接搜索漫画名称。我们提供热血、恋爱、奇幻、动作、悬疑、搞笑、校园、古风等多个分类，方便您快速找到感兴趣的漫画。',
  },
];